
// #region BILLING = '/billing'
export const BILLING = '/billing';
export const BILLING_PLANS = `${BILLING}/plans`;
export const BILLING_PAYNOW = `${BILLING}/pay-now`;
export const BILLING_INVOICES = `${BILLING}/invoices`;
export const BILLING_RESULT = `${BILLING}/payment-result`;
// #endregion

export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const PASSWORD = '/password';
export const REGISTRATION = '/registration';
export const DENIED = '/denied';

export const MAIN = '/main';
export const DARTS_EVENT_MANAGER = '/darts-event-manager';
export const TABLE_TENNIS_EVENT_MANAGER = '/table-tennis-event-manager';
export const SNOOKER_EVENT_MANAGER = '/snooker-event-manager';

export const SEND_EMAIL = '/send-email';
export const ABOUT_DARTS = '/about/darts';

// #region CMS = '/cms/...'
export const CMS = '/cms';
export const CMS_DARTS = `${CMS}/darts`;
export const CMS_DARTS_GAMES = `${CMS_DARTS}/games`;
export const CMS_DARTS_PLAYERS = `${CMS_DARTS}/players`;
export const CMS_DARTS_TOURNAMENT = `${CMS_DARTS}/tournaments`;
export const CMS_DARTS_COMPETITION = `${CMS_DARTS}/competitions`;
export const CMS_DARTS_SERIES = `${CMS_DARTS}/series`;

export const CMS_TABLE_TENNIS = `${CMS}/table-tennis`;
export const CMS_SNOOKER = `${CMS}/snooker`;

export const CMS_ACCESS = `${CMS}/access`;
export const CMS_ACCESS_CLIENTS = `${CMS_ACCESS}/clients`;
export const CMS_ACCESS_USERS = `${CMS_ACCESS}/users`;
export const CMS_ACCESS_LISTENERS = `${CMS_ACCESS}/listeners`;
export const CMS_ACCESS_ROLES = `${CMS_ACCESS}/roles`;
// #endregion

export const LOGGING = '/logging';
export const LOGGING_MESSAGES = `${LOGGING}/logging-messages`;
export const LOGGING_EXCEPTIONS = `${LOGGING}/logging-exceptions`;
export const LOGGING_CONNECTIONS = `${LOGGING}/logging-connections`;


export const DARTS_LIVESCORE = "/darts/livescore/:gameType?/:eventId?/:tourId?";
export const DARTS_SCORING = "/darts-scoring";
export const DARTS_SCORING_values = `${DARTS_SCORING}/:gameType/:gameId`;
export const ACTIVE_GAME_SCORE = "/active-game-score";
export const ACTIVE_GAME_SCORE_values = `${ACTIVE_GAME_SCORE}/:gameType/:leagueId`;
export const MATCH_STATS_TABLE = "/match-stats-table";
export const MATCH_STATS_TABLE_values = `${MATCH_STATS_TABLE}/:gameType/:gameId`;
export const PRE_MATCH_STATS = "/pre-match-stats";
export const PRE_MATCH_STATS_values = `${PRE_MATCH_STATS}/:gameType/:gameId`;
export const POST_MATCH = "/post-match-page";
export const POST_MATCH_values = `${POST_MATCH}/:gameType/:gameId`;

export const DARTS_game = "/darts/:gameId";
export const DARTS_STANDALONE_game = "/darts-adc/:gameId";
export const DARTS_SHOOTOUT_game = "/darts-shootout/:gameId";

export const STATISTICS = "/statistics";
export const PRE_MATCH_ANIMATION = "/pre-match-animation/:gameId";
export const GAME_SCORES_DARTS = "/game-scores-darts/:leagueId";
export const DARTS_LEAGUES = "/darts/leagues/:leagueId/:groupId";


export const DAILY_RESULTS = "/daily-results/:tourId";
// ToDo: �������
export const MATCH_STATS_TABLE_SHOOTOUT = "/shootout-match-stats-table/:gameId/:tourId";
export const ACTIVE_GAME_SCORE_SHOOTOUT = "/shootout-active-game-scores/:gameId";